export default {
  apiURL: 'https://newcumber.fcul.cors.digital',
  websiteURL: 'https://seacucumber.eu',
  languages: ['pt', 'en'],
  listSize: 9,
  defaultLang: 'pt',
};
